"use strict";import{baseStyles as e,CiscoUElement as t,html as s}from"@cisco-u/base";import r from"./testimonial-slide.css.js";export class TestimonialSlide extends t{static get styles(){return[e,r]}render(){return s`<div class="swiper-slide">
      <slot></slot>
    </div>`}}
//# sourceMappingURL=TestimonialSlide.js.map
